var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alert"}},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.show)?_c('p',{class:['alert', _vm.type, 'fehler']},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }